import {css} from '@emotion/react';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {linkToMarketing} from '../lib/url/linkToMarketing';
import useAppTheme from '../styles/useAppTheme';
import useColor from '../styles/useColor';
import useComponent from '../styles/useComponent';
import ExtendedNavLink from './ExtendedNavLink';

/**
 * Renders the footer section for policy-related links and information.
 */
const PolicyFooterSection = () => {
  const {breakpoints, colors, font, spacings} = useAppTheme();
  const {page} = useComponent();
  const {palette} = useColor();
  const {t} = useTranslation();

  const sectionCss = css({
    backgroundColor: palette.background.neutral.defaultColor,
  });

  const sectionContainerCss = css([
    page.lg,
    {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      justifySelf: 'center',
      gap: spacings.px8,
      paddingTop: spacings.px18,
      paddingBottom: spacings.px18,
      fontSize: spacings.px11,
      [breakpoints.sm]: {
        flexDirection: 'row',
        gap: spacings.px22,
      },
    },
  ]);

  const poweredByCss = css([
    {
      color: colors['brown-200'],
      fontWeight: font.weight.bold,
    },
  ]);

  const separatorCss = css({
    width: spacings.px5,
    height: spacings.px5,
    backgroundColor: palette.background.accent.defaultColor,
    borderRadius: '100%',
  });

  const navCss = css({
    display: 'contents',
  });

  const navListCss = css({
    display: 'contents',
    color: colors['brown-300'],
  });

  const copyrightCss = css({
    color: colors['brown-300'],
  });

  return (
    <section css={sectionCss}>
      <div css={sectionContainerCss}>
        <span css={poweredByCss}>{t('footer.powered-by')}</span>
        <div css={separatorCss} />
        <nav css={navCss}>
          <ul css={navListCss}>
            <li>
              <ExtendedNavLink to={linkToMarketing('/privacy-policy')}>
                {t('pages.privacy-policy.page-title')}
              </ExtendedNavLink>
            </li>
            <li>
              <div css={separatorCss} />
            </li>
            <li>
              <ExtendedNavLink to={linkToMarketing('/terms-of-use')}>
                {t('pages.terms-of-use.page-title')}
              </ExtendedNavLink>
            </li>
          </ul>
        </nav>
        <div css={separatorCss} />
        <span css={copyrightCss}>
          {t('common-strings.copyright', {brand: t('common.brand')})}
        </span>
      </div>
    </section>
  );
};

export default PolicyFooterSection;
